import { useEffect } from "react";
import { envEnums } from "../enums/enums";
import { useParams } from "react-router-dom";

function useUpdateDomTitle(title,themeColor){

    const domain = process.env.REACT_APP_DOMAIN; 
    const params = useParams();
    const defaultTitle = domain === 'qcc' && params?.domain === 'i' ? 'Qr Code click': domain === 'qcc'? 'Scan Page': 'Scanned Page';


    useEffect(()=>{
        document.title = title ? title : defaultTitle;
        document.querySelector("meta[name=\"theme-color").content = themeColor ? themeColor : "#ffffff";
    })
}

export default useUpdateDomTitle;